import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "chat-head bg-surface" }
const _hoisted_2 = { class: "chat-agent" }
const _hoisted_3 = { class: "chat-thread text-medium-emphasis" }
const _hoisted_4 = { class: "chat-sub text-disabled" }
const _hoisted_5 = { class: "chat-log" }
const _hoisted_6 = { class: "msg-role text-disabled" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "chat-tools-head text-disabled" }
const _hoisted_9 = { class: "chat-tools-title" }
const _hoisted_10 = { class: "chat-outcome" }
const _hoisted_11 = { class: "chat-outcome-text" }
const _hoisted_12 = { class: "chat-outcome-meta text-disabled" }
const _hoisted_13 = { class: "chat-caption text-disabled" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_ToolCallRow = _resolveComponent("ToolCallRow")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_card, {
      class: "chat",
      color: "background",
      rounded: "lg",
      variant: "flat",
      elevation: "2"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.chat.agent), 1),
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.chat.thread), 1),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.chat.sub), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chat.entries, (entry, i) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              (entry.kind === 'message')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 'm' + i,
                    class: _normalizeClass(["msg", entry.role === 'user' ? 'msg--user' : 'msg--bot'])
                  }, [
                    _createElementVNode("div", _hoisted_6, _toDisplayString(entry.label), 1),
                    _createElementVNode("div", {
                      class: "msg-body",
                      innerHTML: entry.html
                    }, null, 8, _hoisted_7)
                  ], 2))
                : (_openBlock(), _createElementBlock("div", {
                    key: 't' + i,
                    class: "chat-tools"
                  }, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("span", _hoisted_9, [
                        _createVNode(_component_v_icon, {
                          icon: "mdi-wrench-outline",
                          size: "13",
                          class: "text-primary"
                        }),
                        _cache[0] || (_cache[0] = _createTextVNode(" Tool activity "))
                      ]),
                      _createElementVNode("span", null, _toDisplayString(entry.note), 1)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entry.calls, (call, ci) => {
                      return (_openBlock(), _createBlock(_component_ToolCallRow, {
                        key: ci,
                        call: call
                      }, null, 8, ["call"]))
                    }), 128))
                  ]))
            ], 64))
          }), 256))
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("span", _hoisted_11, [
            _createVNode(_component_v_icon, {
              icon: "mdi-check-circle",
              size: "18",
              class: "chat-outcome-icon"
            }),
            _createElementVNode("strong", null, _toDisplayString(_ctx.outcome.headline), 1),
            _createTextVNode(" — " + _toDisplayString(_ctx.outcome.detail), 1)
          ]),
          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.outcome.meta), 1)
        ])
      ]),
      _: 1
    }),
    _createElementVNode("p", _hoisted_13, [
      _createVNode(_component_v_icon, {
        icon: "mdi-message-text-outline",
        size: "15",
        class: "chat-caption__icon"
      }),
      _createTextVNode(" " + _toDisplayString(_ctx.caption), 1)
    ])
  ]))
}